module.exports = ".manipulation-data-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 12px;\n  margin-bottom: 12px; }\n\ntextarea {\n  resize: none; }\n\n.save-button {\n  width: 100%;\n  max-width: 300px;\n  margin: 32px auto 0;\n  display: block; }\n\ncms-form-media {\n  display: block !important;\n  width: 100% !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/forum/forum.component.scss
// module id = ./src/app/forum/forum.component.scss
// module chunks = main